import { render } from "./BayerProfileA.vue?vue&type=template&id=52f2efde&scoped=true"
import script from "./BayerProfileA.vue?vue&type=script&lang=js"
export * from "./BayerProfileA.vue?vue&type=script&lang=js"

import "./BayerProfileA.vue?vue&type=style&index=0&id=52f2efde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f2efde"]])

export default __exports__